import ContentArea from '@episerver/spa-core/Components/ContentArea';
import Page from '@episerver/spa-core/Page';
import React from 'react';
import InternetLobbyPageData from 'app/Models/Content/InternetLobbyPageData';

export default class InternetLobbyPage extends Page<InternetLobbyPageData> {
  render() {
    const {
      data: {mainContentArea},
      context,
    } = this.props;

    return (
      <div className='InternetLobbyPage'>
        <ContentArea noWrap context={context} data={mainContentArea} />
      </div>
    );
  }
}
